import React from "react";
import { Route, Redirect } from "react-router-dom";
import cookie from "./services/cookie";
import { deleteCookies } from "./utils/functions";

export default function PrivateRoute({ component: Component, ...rest }) {
  return (
    <Route
      {...rest}
      render={(props) => {
        const token = cookie().get("token");

        if (!token) {
          deleteCookies();
          return <Redirect to="/login" />;
        }

        return <Component {...props} />;
      }}
    />
  );
}
